var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnvelope(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "url(#pattern0_111_500)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_111_500",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_111_500",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_111_500",
    width: 90,
    height: 90,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAADD0lEQVR4nO2bP4jUQBTG1z+IIIqChWBjYWNjZWNlpZUWaqedpaWNhULaK4RjYdm8L1mIrN1aaWd1NjZeY2NzjYWFhXggqKioT8bbavGSbHYm85L7fvDBwV4umR/ZyZuXucGAEEIIIYQQQgghhBBCCCGEeKQoiuMi8gqAMijLJoCTK8meTqdHALwwMBg1mo3JZHLUy509m80OAXhqYFBqLM+Loji8tFBV3Vci+4CIFAYGp0byOEmSg01cDgA8qToYwCMDg9TIGSVJsr/spgQwKRNd6+sgIvcNDFYjZa3uNFslutYED+AugN8GBq5tRET+iMi9ZQqHOqJrlSxZlt0G8HMPSP4F4E6Zi/F4fGKxFK4r2uVtmqanK2RfBfCtx5J/ALhZ5mA0Gp0C8Gbx2GVEu7zL8/xs2YkAXALwuYeSvwC4Ujb2NE3PANj63/HLinb5kOf5+bITisgFAB9jy4G/bIvIxbIx53l+TkTe7/Y3moj2cmJ0J15urKai/32V0jS93PSrhG7E21TZWPQ835s+HGA/lQ9/EblW9+G/qujG5Q5sx3s5u7LopgU87CbIAs2L6CZLUthMsJaDb9G1myyIL3UxQZtoIUQHv2j4T/CbI5ToLnX+1tqY7kKKNt35k5Yf4KFFuwG9ttb5kwglaXDRIYp/ROrAdUG0ic6frNiB64ro2J2/7ZiNsLZFa6QBR2/txhCtLXf+ok9Z0USjvc6fmddvMUVr4DKrsgMH4FZbZWVU0Qi3cDC3UIouGv6XwiaX/pZEK4D1qj1/APKS4/Mazaz1GGOzJlrd5kkntOKOvCEiLwF8nS9CNrIsu152TOyNmeZEY0f2s0ZbYA2/cDApGh43dVt5hWZZtNbp/HXl30FMi8ZOtqqWz7st492CxcD1d0a0uocegAd1ppLhcHhMRB5a22zZFdHqIiKfAMBVGK5/4eZfF/ezq0TcZ/PfiX6tnRaNDoeiQdHap1A0KFr7FIoGRWufQtGgaO1TKBoUrX0KRYOitU+haFC07gnRhBBCCCGEEEIIIYQQQgghZFDNXwTsX4VEeVWTAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelope);
export default __webpack_public_path__ + "static/media/Envelope.5c2ca676d9c48213395dbfde681eace7.svg";
export { ForwardRef as ReactComponent };